exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DroppableTile-module__drop-tile___3_JYw{transition:all .2s ease-in-out;position:relative;height:100%}.DroppableTile-module__drop-tile___3_JYw,.DroppableTile-module__drop-tile___3_JYw .DroppableTile-module__drop-placeholder___kTRI-{border-radius:4px;background-color:#bdccd4;width:100%}.DroppableTile-module__drop-tile___3_JYw .DroppableTile-module__drop-placeholder___kTRI-{max-height:100%;position:absolute;bottom:-40px}", ""]);

// exports
exports.locals = {
	"drop-tile": "DroppableTile-module__drop-tile___3_JYw",
	"drop-placeholder": "DroppableTile-module__drop-placeholder___kTRI-"
};